module.exports = __webpack_public_path__ + "img/adkhl.d1682a60.png";